import { StoreRootState } from 'src/app/state/state.reducers';
import { createSelector } from '@ngrx/store';

import { ContentStructure } from 'src/app/models/structure/content.structure.model';
import { IntegrationStructure } from 'src/app/models/structure/integration.structure.model';
import { Translations } from 'src/app/models/data/translations.model';
import { DefaultConfigs } from 'src/app/models/data/defaults.model';

export const selectContent = (state: StoreRootState) => state?.content;

export const selectContentDefaults = createSelector(selectContent, (content: ContentStructure) => content?.defaults);

export const selectContentDefaultStatus = createSelector(
  selectContentDefaults,
  (defaults: DefaultConfigs) => defaults?.status
);
export const selectContentFeatures = createSelector(selectContent, (content: any) => content.features);

export const selectedBranch = createSelector(selectContent, (content: any) => content.selectedBranch);

export const selectContentDashboardOperation = createSelector(
  selectContent,
  (content: ContentStructure) => content?.dashboard?.operation
);

export const selectContentDashboardManagement = createSelector(
  selectContent,
  (content: ContentStructure) => content?.dashboard?.management
);

export const selectContentIntegration = createSelector(
  selectContent,
  (content: ContentStructure) => content?.integration
);

export const selectContentIntegrationOrder = createSelector(
  selectContentIntegration,
  (integration: IntegrationStructure) => integration?.order
);

export const selectContentIntegrationDelivery = createSelector(
  selectContentIntegration,
  (integration: IntegrationStructure) => integration?.delivery
);

export const selectContentReports = createSelector(selectContent, (content: ContentStructure) => content?.reports);

export const selectContentIOTDashboard = createSelector(
  selectContent,
  (content: ContentStructure) => content?.iot?.dashboard
);
export const selectContentIOTDevices = createSelector(
  selectContent,
  (content: ContentStructure) => content?.iot?.devices
);

export const selectContentSettings = createSelector(selectContent, (content: ContentStructure) => content?.settings);

export const selectContentTranslations = createSelector(
  selectContent,
  (content: ContentStructure) => content?.translations
);

export const selectContentTranslationsShared = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.SHARED
);

export const selectContentTranslationsNav = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.NAV
);

export const selectContentTranslationsAuth = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.AUTH
);

export const selectContentTranslationsDashboard = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.DASHBOARD
);

export const selectContentTranslationsSettings = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.SETTINGS
);

export const selectContentTranslationsReports = createSelector(
  selectContentTranslations,
  (content: Translations) => content?.REPORTS
);
